<template>
  <div class="d-flex align-items-start justify-content-center min-vh-100 px-0 px-sm-3 py-0 py-sm-5" style="background:#fdf8f0">
    <div class="ps-card bg-white overflow-hidden w-100">


      <!-- Submit error -->
      <div v-if="submitError" class="alert alert-danger d-flex align-items-center mt-3 mb-0">
        <i class="fas fa-exclamation-triangle mr-2"></i>{{ submitError }}
      </div>
      <!-- Body -->
      <div class="p-4">

        <!-- Loading -->
        <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center py-5">
          <i class="fas fa-atom fa-spin fa-2x gold mb-2"></i>
          <p class="text-muted mb-0">Loading &hellip;</p>
        </div>

        <!-- Error -->
        <div v-else-if="error" class="d-flex flex-column align-items-center justify-content-center py-5">
          <i class="fas fa-exclamation-circle fa-2x text-danger mb-2"></i>
          <p class="text-danger mb-0">{{ error }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'ProgramSelection',
  data() {
    return {
      loading: true,
      error: null,
      submitError: null,
    };
  },
  methods: {
    async autoEnroll() {
      const { t } = this.$route.query;
      try {
        const response = await axios.post('onboarding/auto-enroll', {}, {
          params: { t },
        });
        if (response.data.status === 1) {
          this.$store.commit('profileSet', response.data);
          const isNew = response.data.profile?.reg_status === 'pending_setup';
          const challengeId = response.data.challenge_id;
          await this.$router.push(isNew ? `/profile?pid=${challengeId}` : `/programs/${challengeId}`);
        } else {
          this.submitError = response.data.message || 'Something went wrong. Please try again.';
        }
      } catch (e) {
        this.submitError = e.response?.data?.message || 'Something went wrong. Please try again.';
      }
    },
  },
  async created() {
    this.$store.state.show_loading = 0;
    await this.autoEnroll()
  },
};
</script>

<style scoped>
.ps-card {
  max-width: 580px;
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(214,182,116,0.18);
}

@media (max-width: 576px) {
  .ps-card { border-radius: 0; box-shadow: none; min-height: 100vh; }
}
</style>
